import type {
  CustomerZonePostcodeCoverageRequestType,
  CustomerZonePostcodeCoverageResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useCustomerZonePostcodesCoverage = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CustomerZonePostcodeCoverageRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "customer-zones/postcodes/coverage",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as CustomerZonePostcodeCoverageResponseType,
      ),
  });
};
